export const getPriceAsNumber = (price: number | null | undefined): number | undefined => {
  if (price === undefined || price === null) return undefined;
  return price;
};
